/**
 * @about site edit file edit site that already created
 * 
 */

// lib
import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Dropdown, Modal, Button, ModalFooter, ModalBody, Card, Accordion, } from 'react-bootstrap';
import Chips, { Chip } from 'react-chips'
//redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// errror show
import InlineError from "../../components/common/InlineError";

// actions
// notify
import { notify } from "../../components/common/Toaster";
// loader
import Loader from "../common/Loader";

import AddTag from "../../components/common/add_tag/AddTag"
import { getAllUserList } from "../../redux/actions/User";
import { getAllProjectList } from "../../redux/actions/Project";

import AddUser from "../../components/common/add_user/AddUser";
import AddProject from "../../components/common/add_project/AddProject";

import { Select } from 'antd';
import { _ViewPrticularUser, _getProfileType } from "../../config/api/UserService";

import CheckboxTree from 'react-checkbox-tree';
import { getDataAndFilter } from "../../utils/MyFilter"
import { Spinner } from 'react-bootstrap';


// url & api services
import Url from "../../config/env/BaseUrl";
import { _Api } from "../../config/api/Api";


const { Option } = Select;
const children = [];
// site edit screen
class SiteEditGeneral extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoadingState: true,
            inviteNewPopupOpen: false,
            chips: [],
            name: '',
            description: '',
            address: '',
            street: '',
            city: '',
            state: '',
            latitude: '',
            longitude: '',
            tagId: '',
            challanges: '',
            strengths: '',
            nameError: '',
            descriptionError: '',
            addressError: '',
            streetError: '',
            cityError: '',
            stateError: '',
            longitudeError: '',
            latitudeError: '',
            userId: '',
            user: [],
            user1: [],
            showTagName: '',
            projectId: '',
            projectNameShow: '',

            fileName: '',
            fileUploadFileError: '',
            coverImg: '',
            clientUserList: [],
            clientId: '',
            clientName: '',

            nodeData: [],
            checked: [],
            expanded: [],
            profileError: '',
            isSpinner:false,
            toggleState:false
        }

    }


    onChange = chips => {
        this.setState({ chips });
    }


    componentDidMount() {
        // this.multiDropdowm();
        this.props.action.getAllUserList({ tagType: 2, folder: '' });
        this.getSiteDetails();
        this.props.action.getAllProjectList({ status: "1", tagType: 2, folder: '' });
        // this.getDataProfileType()

    }


    handleSecleted = (e) => {

        this.setState({ checked: e })
    }



    getDataProfileType = async () => {


        let resp = await _Api(Url.ADMIN_GET_PROFILE_TYPE.method, Url.ADMIN_GET_PROFILE_TYPE.url, "", 4)

        let arr1 = await getDataAndFilter(resp.responseData.profileInfo, 1)
        let arr2 = await getDataAndFilter(resp.responseData.profileInfo, 2)
        let arr3 = await getDataAndFilter(resp.responseData.profileInfo, 3)
        let arr4 = await getDataAndFilter(resp.responseData.profileInfo, 4)
        let arr5 = await getDataAndFilter(resp.responseData.profileInfo, 5)
        let arr6 = await getDataAndFilter(resp.responseData.profileInfo, 6)


        let fnArr = arr1.map((item1, index1) => (
            {
                value: `${item1._id}`,
                label: item1.levelName,
                children: arr2.filter(item2 => item2.parentLevel == item1._id).map((data, index2) => ({

                    value: `${data._id}`,
                    label: data.levelName,
                    children: arr3.filter(item3 => item3.parentLevel == data._id).map((data2, index3) => ({

                        value: `${data2._id} `,
                        label: data2.levelName,
                        children: arr4.filter(item4 => item4.parentLevel == data2._id).map((data3, index4) => ({

                            value: `${data3._id} `,
                            label: data3.levelName,
                            children: arr5.filter(item5 => item5.parentLevel == data3._id).map((data4, index5) => ({

                                value: `${data4._id} `,
                                label: data4.levelName,
                                children: arr6.filter(item6 => item6.parentLevel == data4._id).map((data5, index5) => ({

                                    value: `${data5._id} `,
                                    label: data5.levelName,
                                }))
                            }))
                        }))
                    }))
                }))


            }
        ))



        setTimeout(() => {
            fnArr.forEach((item, index) => {

                if (item.children.length == 0) {
                    delete fnArr[index].children
                }

                if (item.children)
                    item.children.forEach((item2, index2) => {
                        if (item2.children.length == 0) {
                            delete fnArr[index].children[index2].children
                        }
                        else {
                            if (item2.children)
                                item2.children.forEach((item3, index3) => {
                                    if (item3.children.length == 0) {
                                        delete fnArr[index].children[index2].children[index3].children
                                    }
                                    else {

                                        if (item3.children)
                                            item3.children.forEach((item4, index4) => {
                                                if (item4.children.length == 0) {
                                                    delete fnArr[index].children[index2].children[index3].children[index4].children
                                                }
                                                else {

                                                    if (item4.children)
                                                        item4.children.forEach((item5, index5) => {
                                                            if (item5.children.length == 0) {
                                                                delete fnArr[index].children[index2].children[index3].children[index4].children[index5].children
                                                            }
                                                        })
                                                }
                                            })
                                    }


                                })


                        }
                    })
            })

            this.setState({ nodeData: fnArr, isSpinner:false })

        }, 3000)



    }
    

    // getUser details
    getSiteDetails = () => {
        try {
            if (this.props.match.params)
            _Api(Url.ADMIN_VIEW_SITE.method, Url.ADMIN_VIEW_SITE.url, "",this.props.match.params.id  )
                    .then(resp => {
                        const {
                            created,
                            firstName,
                            address,
                            city,
                            desc,
                            folder,
                            clientId,
                            clientName,
                            profile,


                            project,
                            role,
                            street,
                            status,
                            state,
                            tag,

                            lat,
                            long,
                            cover,
                            challanges,
                            strengths,
                            _id } = resp.responseData.siteData

                        this.setState({
                            user1: resp.responseData.siteData.user,
                            clientName,
                            fileName: cover,
                            clientId,
                            challanges,
                            isSpinner:false,
                            nodeData:JSON.parse(profile),
                            // checked: profile.split(','),
                            checked: profile  == undefined || profile.length == 0 ? []:profile.split(','),
                            projectNameShow: project == undefined ? '' : project.projectName,
                            projectId: project == undefined ? '' : project._id,
                            tagId: tag == undefined ? '' : tag._id,
                            showTagName: tag == undefined ? '' : tag.tagName,
                            strengths,
                            latitude: lat == undefined ? '' : lat,
                            longitude: long == undefined ? '' : long,
                            address: address == undefined ? '' : address,
                            city,
                            state,
                            street: street == "undefined" ? '' : street,
                            description: desc,
                            showUserName: resp.responseData.siteData.siteName, name: resp.responseData.siteData.siteName, isLoadingState: false, folderName: folder.folderName, created, firstName, folder, role, status, _id
                        }, () => this.getClientsUsers())

                    })
                    .catch(err => {

                    })

        } catch (error) {

        }
    }

    getClientsUsers = () => {
        try {
            if (this.state.clientId) {
                // let req = { clientId: this.state.clientId,  }
                let req = { clientId: this.state.clientId, projectId: this.state.projectId, }
                _ViewPrticularUser(req)
                    .then(resp => {                   
                        this.setState({ clientUserList: resp.responseData.usersInfo, isLoadingState: false, user: this.state.user1 })
                        
                    })
                    .catch(err => {

                    })
            }
        }
        catch (err) { }
    }


    //handle on handleChangeAll
    handleChangeAll = (e) => {
        this.setState({ [e.target.name]: e.target.value, latitudeError: '', longitudeError: '' });

    }

    // on submit
    onSaveSite = () => {
        try {
            const {
                name,
                description,
                address,
                street,
                city,
                state,
                latitude,
                longitude,
                checked,
                userId,
                user,
                _id, challanges,
                strengths,

            } = this.state
            if (name == "") {
                this.setState({ nameError: "*Please enter site name." })
            }
            else if (description == "") {
                this.setState({ descriptionError: "*Please enter description." })
            }
            else if (this.state.coverImg != "" && this.state.coverImg.type.split("/")[0] != "image") {

                this.setState({ fileUploadFileError: "*Please add a valid cover image.", })
            }
            

            else {
                this.setState({ isLoadingState: true })
                let formData = new FormData()
                formData.append("siteName", name);
                formData.append("siteId", this.state._id);
                formData.append("street", street);
                formData.append("project", this.state.projectId);
                // formData.append("desc", description)        
                formData.append("user", this.state.user);
                formData.append("tag", this.state.tagId)
                formData.append("address", address)
                formData.append("cover", this.state.coverImg)
                formData.append("city", city)
                formData.append("state", state)
                formData.append("lat", latitude)
                formData.append("long", longitude)
                // formData.append("code", this.state.mapContent) 
                formData.append("projectType", 'S')
                formData.append("profile",JSON.stringify(this.state.nodeData))






                _Api(Url.ADMIN_EDIT_SITE.method, Url.ADMIN_EDIT_SITE.url, formData).then(resp => {
                    notify("success", resp.responseData.message)
                    this.setState({ isLoadingState: false, })
                    this.props.history.push(`/sites/${this.props.match.params.folderId}`, { state: this.state.folderName });


                }).catch(err => {
                    this.setState({ isLoadingState: false, })

                    if (err.error)
                        notify("err", err.error.message)
                    else if (err)
                        notify("err", err.message)

                })




            }


        } catch (err) {
            this.setState({ isLoadingState: false })

        }




    }

    // on image upload
    onImageUpload = e => {
        let file = e.target.files[0]
        this.setState({ coverImg: file, fileName: URL.createObjectURL(file), fileUploadFileError: '' })
    }



    // redirect to
    goBack = () => {
        this.props.history.push(`/sites/${this.props.match.params.folderId}`, { state: this.state.folderName });
    }
    // adding popup
    openInviteNewPopupOpen = () => {
        this.setState({
            inviteNewPopupOpen: !this.state.inviteNewPopupOpen
        })
    }
    closeModal = () => {
        this.setState({
            inviteNewPopupOpen: false,
        })
    }

    handleAddTag = (e) => {
        if (e.target.name == "user")
            this.clickChild2()
        else if (e.target.name == "tag")
            this.clickChild()
        else if (e.target.name == "project")
            this.clickChild3()
        this.setState({ inviteNewPopupOpen: false })
    }


    handleChange = (value) => {

    }
    handleOnSelect = (d) => {
        try {
            if (this.state.user.indexOf(d) == -1) {
                this.setState({ user: [...this.state.user, d] })

            }
            else if (this.state.user.indexOf(d) != -1) {
                this.setState({ user: this.state.user.filter(item => item != d) })

            }
        }
        catch (err) { }

    }

    handleCheckedBox = (item, index = '', index2='') => {
        item.isChecked = !item.isChecked
        if(item.children){
            item.children.forEach(item2=>{ 
                item2.isChecked = item2.isOther ? item2.isChecked : !item2.isChecked
                if(item2.children){
                    item2.children.forEach(item3=>{ 
                        item3.isChecked = item3.isOther ? item3.isChecked : !item3.isChecked
                        if(item3.children){
                            item3.children.forEach(item4=>{ 
                                item4.isChecked = item4.isOther ? item4.isChecked : !item4.isChecked
                                if(item4.children){
                                    item4.children.forEach(item5=>{ 
                                        item5.isChecked = item5.isOther ? item5.isChecked : !item5.isChecked
                                        
                                    
                                    } )
                                    
                                }
                                
                            
                            } )
                            
                        }
                    
                    
                    } )
                    
                }
            
            } )
            
        }
        this.setState({toggleState:!this.state.toggleState})       
    }
    
    handleOtherInput = (e, item, index) => {
        item.inputValue = e.target.value
        this.setState({toggleState:!this.state.toggleState})
    }
    

    render() {


        return (
            <>

                <div>
                    {this.state.isLoadingState && <Loader />}
                    <div className="col-sm-12">
                    {/* <a href="#" > <i class="fa fa-pencil float-right edit_pencil" aria-hidden="true"></i></a> */}
                </div>
                    <div className="row">
                        <div className="col-sm-6">
                            <form>
                                <div class="form-group">
                                    <label for="email">Name</label><span className="impFields">*</span>
                                    <input type="text"
                                        className={`form-control ${this.state.nameError != '' ? 'is-invalid' : ''}`}
                                        id="Name"
                                        placeholder="Name"
                                        maxLength={30}
                                        name='name'
                                        value={this.state.name}
                                        onChange={this.handleChangeAll}
                                    />
                                    <InlineError
                                        message={this.state.nameError}
                                    />
                                </div>

                                <div class="form-group row df-end">
                                    <div className="col-md-8" >
                                        <label for="email">Cover image</label><span className="impFields">*</span><br />
                                        <img
                                            src={this.state.fileName}
                                            style={{}}
                                            className="upload_fileimg"
                                        />

                                        <input
                                            type="file"
                                            style={{ display: 'none' }}
                                            aria-hidden="true"
                                            accept="image/png,image/jpeg"
                                            className={`form-control ${this.state.fileUploadFileError != '' ? 'is-invalid' : ''}`}
                                            id="sel1"
                                            ref="fileUploader"
                                            files={this.state.iconImag}
                                            onChange={this.onImageUpload}
                                        />


                                        <InlineError
                                            message={this.state.fileUploadFileError}
                                        />


                                    </div>
                                    <div className="col-md-4"><button type="button" onClick={() => this.refs.fileUploader.click()} class="btn btn btn-default P1016 col-sm-12">Browse</button></div>

                                </div>



                                <div class="form-group row df-end">
                                    <div className="col-md-9">
                                        <label >Tag</label>
                                        <select class="form-control" id="sel1" name="tagId" onChange={this.handleChangeAll}>

                                            {this.state.showTagName ? <option key={-2} selected hidden value={this.state.tagId} >{this.state.showTagName}</option> : <option key={-1} value={"select"} selected hidden  >{"Select tag"}</option>}
                                            {
                                                this.props.tagsList && this.props.tagsList.map((item, index) =>
                                                    (
                                                        <option key={index} value={item._id}>{item.tagName}</option>
                                                    )

                                                )
                                            }
                                        </select>
                                    </div>
                                    <AddTag
                                        setClick={click => this.clickChild = click}
                                        closeModalAddTag={() => this.setState({ inviteNewPopupOpen: true })}
                                    />
                                    <AddUser
                                        setClick={click => this.clickChild2 = click}
                                        closeModalAddTag={() => this.setState({ inviteNewPopupOpen: true })}

                                    />
                                    <AddProject
                                        setClick={click => this.clickChild3 = click}
                                        closeModalAddTag={() => this.setState({ inviteNewPopupOpen: true })}

                                    />
                                    <div className="col-md-3"><button type="button" class="btn btn-primary btn-blue P1016 col-sm-12" name="tag" onClick={this.handleAddTag}>Add Tag</button></div>
                                </div>                               
                                <div class="form-group row df-end">
                                    <div className="col-md-12">
                                        <label for="email">Project</label>
                                        <input type="text"
                                            className={`form-control`}
                                            id="Name"

                                            value={this.state.projectNameShow}

                                            disabled
                                        />
                                    </div>


                                </div>
                                <br />

                                <div class="form-group row df-end">
                                    <div className="col-md-12">
                                        <label for="email">Client</label>
                                        <input type="text"
                                            className={`form-control`}
                                            id="Name"
                                            value={this.state.clientName}
                                            disabled
                                        />
                                    </div>


                                </div>
                                <br />

                                <div class="form-group row df-end">
                                    <div className="col-md-12">
                                        <label for="email">User</label><br />                                   
                                        <Select
                                            mode="multiple"
                                            placeholder="Please select users"
                                            // defaultValue={}
                                            value={this.state.user}
                                            onChange={this.handleChange}
                                            onSelect={(i) => this.handleOnSelect(i)}
                                            onDeselect={(i) => this.handleOnSelect(i)}
                                        >
                                            {this.state.clientUserList.map((item, index) => (
                                                <Option value={item._id} key={index}>{`${item.firstName} ${item.lastName}`}</Option>

                                            ))}
                                        </Select>
                                    </div>
                                    {/* <div className="col-md-3"><button type="button" class="btn btn-primary btn-blue P1016 col-sm-12" name="user" onClick={this.handleAddTag}>Add User</button></div> */}

                                </div>
                                <div class="form-group">
                                    <label for="email">Address</label>
                                    <textarea rows="4" cols="50"
                                        className={`form-control ${this.state.addressError != '' ? 'is-invalid' : ''}`}
                                        id="Address"
                                        placeholder="Enter Address"
                                        maxLength={256}
                                        name='address'
                                        value={this.state.address}
                                        onChange={this.handleChangeAll}
                                    />
                                    <InlineError
                                        message={this.state.addressError}
                                    />
                                </div>
                                <div class="form-group">
                                    <label for="email">Street</label>
                                    <input type="text"
                                        className={`form-control ${this.state.streetError != '' ? 'is-invalid' : ''}`}
                                        maxLength={50}
                                        id="Street"
                                        placeholder="Street"
                                        name='street'
                                        value={this.state.street}
                                        onChange={this.handleChangeAll}
                                    />
                                    <InlineError
                                        message={this.state.streetError}
                                    />
                                </div>

                                <div class="form-group row df-end">
                                    <div className="col-md-6">
                                        <label for="email">City</label>
                                        <input type="text"
                                            className={`form-control ${this.state.cityError != '' ? 'is-invalid' : ''}`}
                                            maxLength={50}
                                            id="City" placeholder="City"
                                            name='city'
                                            value={this.state.city}
                                            onChange={this.handleChangeAll}
                                        />
                                        <InlineError
                                            message={this.state.cityError}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label for="email">State</label>
                                        <input type="text"
                                            className={`form-control ${this.state.stateError != '' ? 'is-invalid' : ''}`}
                                            maxLength={50}
                                            id="State" placeholder="State"
                                            name='state'
                                            value={this.state.state}
                                            onChange={this.handleChangeAll}
                                        />
                                        <InlineError
                                            message={this.state.stateError}
                                        />
                                    </div>
                                </div>
                                <div class="form-group row df-end">
                                    <div className="col-md-6 heih93">
                                        <label for="email">Latitute</label>
                                        <input type="number"
                                            className={`form-control ${this.state.latitudeError != '' ? 'is-invalid' : ''}`}
                                            maxLength={30}
                                            id="Latitude" placeholder="Latitude"
                                            name='latitude'
                                            value={this.state.latitude}
                                            onChange={this.handleChangeAll}
                                        />
                                        <InlineError
                                            message={this.state.latitudeError}
                                        />
                                    </div>
                                    <div className="col-md-6 heih93">
                                        <label for="email">Longitude</label>
                                        <input type="number"
                                            className={`form-control ${this.state.longitudeError != '' ? 'is-invalid' : ''}`}
                                            maxLength={30}
                                            id="Longitude" placeholder="Longitude"
                                            name='longitude'
                                            value={this.state.longitude}
                                            onChange={this.handleChangeAll}
                                        />
                                        <InlineError
                                            message={this.state.longitudeError}
                                        />
                                    </div>
                                </div>                              
                                <br />
                                <div class="form-group float-right">
                                    <button type="button" class="btn btn-pink mR-20" onClick={this.goBack}>Exit</button>
                                    <button type="button" class="btn btn-primary btn-blue" onClick={this.onSaveSite}>Save</button>
                                </div>
                            </form>
                        </div>
                        <div className="col-sm-5 offset-sm-1">
                        <p>Site Profile</p>
                        {
                            this.state.isSpinner  &&
                            <Spinner animation="border" role="status">
                                <span className="sr-only">Loading...</span>
                            </Spinner>
                        }
                                   <Accordion defaultActiveKey="00000000">
                            {
                                this.state.nodeData.map((item, index) => (
                                    <Card>
                                        <Card.Header className="cm_accordion_header">
                                            <Accordion.Toggle as={Button} variant="link" eventKey={`${index}`} >
                                                {item.children && <i class="fa fa-chevron-right" aria-hidden="true"> </i>}<input type="checkbox" checked={item.isChecked} onClick={() => this.handleCheckedBox(item)} name="vehicle1" value="Bike" /> {item.label}
                                            </Accordion.Toggle>
                                        </Card.Header>
                                        <Accordion.Collapse eventKey={`${index}`}>
                                            <Card.Body className="cm_accordion_body">
                                                {
                                                    item.children && item.children.map((item2, index2) => (
                                                        <Accordion defaultActiveKey="00000">
                                                            <Card.Header className="cm_accordion_header">
                                                                <Accordion.Toggle as={Button} variant="link" eventKey={`${index2}`} >
                                                                    {item2.children && <i class="fa fa-chevron-right" aria-hidden="true"> </i>}<input type="checkbox" checked={item2.isChecked} onClick={() => this.handleCheckedBox(item2)} name="vehicle1" value="Bike" />


                                                                    <span>{item2.label} </span>
                                                                    {item2.isOther && item2.isChecked &&
                                                                        <>
                                                                            <input type="text" value = {item2.inputValue} placeholder = "Enter here..." className="form-control " onChange={(e) => this.handleOtherInput(e, item2)} />
                                                                        </>
                                                                    }
                                                                </Accordion.Toggle>
                                                            </Card.Header>
                                                            <Accordion.Collapse eventKey={`${index2}`}>
                                                                <Card.Body className="cm_accordion_body">
                                                                    {
                                                                        item2.children && item2.children.map((item3, index3) => (
                                                                            <Accordion defaultActiveKey="0000">

                                                                                <Card.Header className="cm_accordion_header">
                                                                                    <Accordion.Toggle as={Button} variant="link" eventKey={`${index3}`} >
                                                                                        {item3.children && <i class="fa fa-chevron-right" aria-hidden="true"> </i>}<input type="checkbox" checked={item3.isChecked} onClick={() => this.handleCheckedBox(item3)} name="vehicle1" value="Bike" />
                                                                                        <span>{item3.label} </span>
                                                                                        {item3.isOther && item3.isChecked &&
                                                                                            <>
                                                                                               <input type="text" value = {item3.inputValue} placeholder = "Enter here..." className="form-control " onChange={(e) => this.handleOtherInput(e, item3)} />
                                                                                            </>
                                                                                        }

                                                                                    </Accordion.Toggle>
                                                                                </Card.Header>
                                                                                <Accordion.Collapse eventKey={`${index3}`}>
                                                                                    <Card.Body className="cm_accordion_body">
                                                                                        {
                                                                                            item3.children && item3.children.map((item4, index4) => (
                                                                                                <Accordion defaultActiveKey="0000">

                                                                                                    <Card.Header className="cm_accordion_header">
                                                                                                        <Accordion.Toggle as={Button} variant="link" eventKey={`${index4}`} >
                                                                                                            {item4.children && <i class="fa fa-chevron-right" aria-hidden="true"> </i>}<input type="checkbox" checked={item4.isChecked} onClick={() => this.handleCheckedBox(item4)} name="vehicle1" value="Bike" />


                                                                                                            <span>{item4.label} </span>
                                                                                                            {item4.isOther && item4.isChecked &&
                                                                                                                <>
                                                                                                                    <input type="text" value = {item4.inputValue} placeholder = "Enter here..." className="form-control " onChange={(e) => this.handleOtherInput(e, item4)} />
                                                                                                                </>
                                                                                                            }
                                                                                                        </Accordion.Toggle>
                                                                                                    </Card.Header>
                                                                                                    <Accordion.Collapse eventKey={`${index4}`}>
                                                                                                        <Card.Body className="cm_accordion_body">

                                                                                                            {
                                                                                                                item4.children && item4.children.map((item5, index5) => (
                                                                                                                    <Accordion defaultActiveKey="0000">

                                                                                                                        <Card.Header className="cm_accordion_header">
                                                                                                                            <Accordion.Toggle as={Button} variant="link" eventKey={`${item5}`} >
                                                                                                                                {item5.children && <i class="fa fa-chevron-right" aria-hidden="true"> </i>}<input type="checkbox" checked={item5.isChecked} onClick={() => this.handleCheckedBox(item5)} name="vehicle1" value="Bike" />



                                                                                                                                <span>{item5.label} </span>
                                                                                                                                {item5.isOther && item5.isChecked &&
                                                                                                                                    <>
                                                                                                                                      <input type="text" value = {item5.inputValue} placeholder = "Enter here..." className="form-control " onChange={(e) => this.handleOtherInput(e, item5)} />
                                                                                                                                    </>
                                                                                                                                }


                                                                                                                            </Accordion.Toggle>
                                                                                                                        </Card.Header>
                                                                                                                        <Accordion.Collapse eventKey={`${item5}`}>
                                                                                                                            <Card.Body className="cm_accordion_body">
                                                                                                                            {
                                                                                                                item5.children && item5.children.map((item6, index6) => (
                                                                                                                    <Accordion defaultActiveKey="0000">

                                                                                                                        <Card.Header className="cm_accordion_header">
                                                                                                                            <Accordion.Toggle as={Button} variant="link" eventKey={`${item6}`} >
                                                                                                                                {item6.children && <i class="fa fa-chevron-right" aria-hidden="true"> </i>}<input type="checkbox" checked={item6.isChecked} onClick={() => this.handleCheckedBox(item6)} name="vehicle1" value="Bike" />



                                                                                                                                <span>{item6.label} </span>
                                                                                                                                {item6.isOther && item6.isChecked &&
                                                                                                                                    <>
                                                                                                                                      <input type="text" value = {item6.inputValue} placeholder = "Enter here..." className="form-control " onChange={(e) => this.handleOtherInput(e, item6)} />
                                                                                                                                    </>
                                                                                                                                }


                                                                                                                            </Accordion.Toggle>
                                                                                                                        </Card.Header>
                                                                                                                        <Accordion.Collapse eventKey={`${item6}`}>
                                                                                                                            <Card.Body className="cm_accordion_body">
                                                                                                                                

                                                                                                                            </Card.Body>
                                                                                                                        </Accordion.Collapse>

                                                                                                                    </Accordion>

                                                                                                                ))
                                                                                                            }


                                                                                                                                

                                                                                                                            </Card.Body>
                                                                                                                        </Accordion.Collapse>

                                                                                                                    </Accordion>

                                                                                                                ))
                                                                                                            }


                                                                                                        </Card.Body>
                                                                                                    </Accordion.Collapse>

                                                                                                </Accordion>

                                                                                            ))
                                                                                        }
                                                                                    </Card.Body>
                                                                                </Accordion.Collapse>

                                                                            </Accordion>

                                                                        ))
                                                                    }

                                                                </Card.Body>
                                                            </Accordion.Collapse>

                                                        </Accordion>

                                                    ))
                                                }

                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>


                                ))
                            }

                        </Accordion>

                                </div>
                    </div>

                </div>


            </>
        );

    }
}


// get store data
const mapStateToProps = state => {
    return {
        isLoading: state.loading.isLoading,
        isLoggedIn: state.login.isLoggedIn,
        tagsList: state.tags.tagInfo,
        usersInfo: state.users.userInfo,
        projectInfo: state.projects.projectInfo,
    }
}

// dispatch action
const mapDispatchToProps = dispatch => {
    return {
        action: bindActionCreators({ getAllProjectList, getAllUserList }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SiteEditGeneral);